export default {
  withdraw: {
    title: '出金',
    subtitle: '迅速、安全、便利',
    secureEncrypted: '安全で暗号化',
    fiatOrCash: '法定通貨/現金',
    processing: '処理中...',
    select: '選択',
    withdrawCurrency: '出金通貨',
    chooseNetwork: 'ネットワークを選択',
    channel: 'チャネル',
    withdrawalAddress: '出金アドレス',
    pixKeyType: 'PIXキータイプ',
    accountNumber: '口座番号',
    enterAccountNumber: '口座番号を入力してください',
    accountName: '口座名義',
    enterAccountName: '口座名義人の氏名を入力してください',
    pixKey: 'PIXキー',
    enterPixKey: 'PIXキーを入力してください',
    cpf: 'CPF',
    enterCpf: 'CPFを入力してください',
    bankName: '銀行名',
    enterBankName: '銀行名を入力してください',
    branch: '支店',
    enterBranch: '支店を入力してください（任意）',
    phone: '電話番号',
    enterPhone: '電話番号を入力してください（任意）',
    email: 'メール',
    enterEmail: 'メールを入力してください（任意）',
    available: '出金可能',
    amountPlaceholder: '金額（{unit}）',
    min: '最小',
    max: '最大',
    totalWithdrawalAmount: '出金総額:',
    fee: '手数料:',
    withdrawalAmount: '出金額:',
    fundsSafeTitle: 'お客様の資金は安全に保管されています',
    fundsSafeDesc: '業界最高水準のセキュリティで取引と個人情報を保護します。',
    enterWithdrawalAddress: '出金アドレスを入力してください',
    enterAccountNumberRequired: '口座番号を入力してください',
    selectChannelRequired: 'チャネルを選択してください',
    enterAccountNameRequired: '口座名義人の氏名を入力してください',
    selectPixKeyTypeRequired: 'PIXキータイプを選択してください',
    enterCpfRequired: 'CPFを入力してください',
    enterValidAmount: '有効な金額を入力してください',
    minWithdrawal: '最低出金額: {amount} {unit}',
    maxWithdrawal: '最高出金額: {amount} {unit}',
    insufficientBalance: '利用可能残高が不足しています',
    withdrawalRejected: '出金が拒否されました',
    submittedPendingReview: '出金申請を送信しました。審査待ちです',
    submittedPayoutInProgress: '出金申請を送信しました。送金処理中です',
    withdrawalFailed: '出金に失敗しました',
    withdrawalFailedRetry: '出金に失敗しました。もう一度お試しください',
  },
};
